import { AppContext, Booking, BookingData } from "../../../AppDataProvider/AppDataProvider";
import { Checkbox as BaseCheckbox, Divider as BaseDivider } from "../../../common/components";
import { marginBottom, marginRight, marginTop, padding, typography } from "../../../common/styles";
import React, { useContext } from "react";
import { applyOpacity } from "../../../common/styles/utils";
import { Item } from "./Item/Item";
import { PartRequired } from "../../../utils/types";
import { requireBookingDataFields } from "../../../utils";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
type AvailabilityStepBookingData = PartRequired<BookingData, "duration" | "organisation" | "recurringBooking" | "service" | "timezone">;
type ListProps = {
  isSelectAllBookingsToggleChecked: boolean;
  onSelectBooking: (selectedBooking: Booking) => void;
  onToggleAllBookingsChecked: () => void;
  selectedBookings: Booking[];
};
export function List(options: ListProps): React.ReactElement {
  const {
    isSelectAllBookingsToggleChecked,
    onSelectBooking,
    onToggleAllBookingsChecked,
    selectedBookings
  } = options;
  const {
    t,
    i18n
  } = useTranslation();
  const {
    appData
  } = useContext(AppContext);
  requireBookingDataFields<AvailabilityStepBookingData>(appData.bookingData, ["service", "timezone", "recurringBooking", "duration"]);
  const {
    recurringBooking,
    timezone
  } = appData.bookingData;
  const {
    recurring
  } = recurringBooking;
  const {
    recurrenceType
  } = recurring;
  const {
    bookings
  } = recurring;
  const bookingSelectionEnabled = recurrenceType == "INDIVIDUAL_BOOKINGS";
  let prevMonthDisplay = "";
  return <BookingList data-sentry-element="BookingList" data-sentry-component="List" data-sentry-source-file="List.tsx">
      {bookingSelectionEnabled && <>
          <Checkbox aria-label={t("toggleSelectAllBookings")} checked={isSelectAllBookingsToggleChecked} onChange={() => {
        onToggleAllBookingsChecked();
      }} />
          <Divider />
        </>}

      {bookings.filter(booking => booking.remainingSpaces > 0).map(booking => {
      const {
        _id: bookingId,
        start
      } = booking;
      const startDate = new Date(start);
      const monthDisplay = new Intl.DateTimeFormat(i18n.language, {
        month: "long",
        timeZone: timezone
      }).format(startDate);
      const yearDisplay = new Intl.DateTimeFormat(i18n.language, {
        timeZone: timezone,
        year: "numeric"
      }).format(startDate);
      const displayMonthYear = monthDisplay !== prevMonthDisplay;
      prevMonthDisplay = monthDisplay;
      return <React.Fragment key={bookingId}>
              {displayMonthYear && <MonthYear>
                  <Month>{monthDisplay}</Month>
                  <Year>{yearDisplay}</Year>
                </MonthYear>}

              <Item booking={booking} onSelectBooking={onSelectBooking} selectedBookings={selectedBookings} />
            </React.Fragment>;
    })}
      <Divider data-sentry-element="Divider" data-sentry-source-file="List.tsx" />
    </BookingList>;
}
const BookingList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  ${padding.zero}
  ${marginTop.l}
`;
const Checkbox = styled(BaseCheckbox)`
  align-self: flex-end;
  ${marginBottom.s}
`;
const Divider = styled(BaseDivider)`
  ${marginTop.zero}
  ${marginBottom.m}
`;
const MonthYear = styled.div`
  display: flex;
  ${marginBottom.m}
`;
const Month = styled.div`
  ${typography.bodyBold}
  ${marginRight.s}
`;
const Year = styled.div`
  ${typography.body};
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.6)};
`;